type UpdatedCallback = (busy : boolean) => void;

export class SpinnerManager {
    static callbacks : Set<UpdatedCallback> = new Set<UpdatedCallback>();

    static onUpdate(updateHandler : UpdatedCallback)
    {
        SpinnerManager.callbacks.add(updateHandler);
    }

    static removeUpdateEvent(updateHandler : UpdatedCallback)
    {
        SpinnerManager.callbacks.delete(updateHandler);
    }

    static setState(busy : boolean)
    {
        SpinnerManager.callbacks.forEach(callback => {
            callback(busy);
        });
    }
}

